import {apiFetch} from '../../Config/api'

export function requestSubscription(data) {
    return apiFetch('account/requestsubscription', data)
}
export function editSettings(data) {
    return apiFetch('account/settings', data)
}
